<template>
    <share-link-setup
        v-if="page.id"
        v-on:submit="submitSetupData($event)"
        :link="page.share_link"
        :title="page.title"
        :loading="isLoading"
        :errors="errors"
    ></share-link-setup>
</template>

<script>
import http from "@/axios.js"
import ShareLinkSetup from "@/components/ShareLinkSetup"

export default {
    name: "CaseSessionSetup",
    components: {
        ShareLinkSetup,
    },
    data() {
        return {
            page: {
                share_link: {
                    require_passcode: false,
                    identification_method: "none",
                },
                title: "",
            },
            isLoading: false,
            errors: [],
        }
    },
    computed: {
        pageID() {
            return this.$route.params.id
        },
        shareLinkID() {
            return this.$route.params.shareLinkID
        },
        pageSetupUrl() {
            return `/api/students/pages/${this.pageID}/share/${this.shareLinkID}/setup/`
        },
    },
    methods: {
        fetchData() {
            let vm = this
            http.get(this.pageSetupUrl).then((response) => {
                vm.page = response.data
                // Store the page in the datastore so that we can read metadata from it in other
                // places, like the owning-organization's custom logo.
                vm.$store.commit("setPage", response.data)
            })
        },
        submitSetupData(setupData) {
            this.isLoading = true
            let vm = this
            http.post(this.pageSetupUrl, setupData)
                .then((response) => {
                    if (response.data.is_valid) {
                        // Proceed to the session view.
                        vm.$router.push({
                            name: "PageViewerShare",
                            params: {
                                id: vm.pageID,
                                viewerID: response.data.viewer_id,
                            },
                        })
                    } else {
                        vm.errors = response.data.errors
                    }
                })
                .finally(() => (vm.isLoading = false))
        },
    },
    mounted() {
        this.fetchData()
    },
}
</script>
